export default __webpack_public_path__ + "static/media/button talkback-1.ca3a98f3.png";